Vue.component('givePack', {
  template: templates.givePack,
  data() {
    return {
      model: {
        packId: null,
        packs: {},
        searchResults: [],
        saving: false
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    searchUsers() {
      const c = this;
      let names = [];
      const twitchDisplayName = $('[name="unlock-user"]').val();

      userService.search({twitchDisplayName: twitchDisplayName})
        .then(function (response) {
          c.model.searchResults = response.data;
          for (let data of response.data) {
            names.push(data.twitchDisplayName);
          }
          
          $('[name="unlock-user"]').autocomplete({
            source: names
          });
        })
        .catch(function (error) {
        
        });
    },
    getUserId(twitchDisplayName, callback) {
      const c = this;
      for (let user of c.model.searchResults) {
        if (user.twitchDisplayName == twitchDisplayName) {
          callback(user.twitchId);
          return;
        }
      }

      twitchAPI.getUserByLogin(twitchDisplayName, function(userData) {
          for (let data of userData) {
            callback(data.id);
            return;
          }
          
          utils.alert.error(`User doesn't exist!`);
      });
    },
    save() {
      const c = this;
      const twitchDisplayName = $('[name="unlock-user"]').val();
      
      if (c.model.saving) {
        return;
      }

      c.getUserId(twitchDisplayName, function(twitchId) {

        if (!twitchId || !c.model.packId) {
          utils.alert.error('User and pack required!');
          return;
        }

        const data = {
          twitchId: twitchId,
          packId: c.model.packId
        }

        unlockQueueService.save(data)
          .then(function (response) {
            utils.alert.success(`Pack given to ${twitchDisplayName}`);
            c.reset();
          })
          .catch(function (error) {
            utils.alert.error('Somthing went wrong giving this pack!');
          });

      });
    },
    reset() {
      const c = this;
      $('[name="unlock-user"]').val('');
      c.model.packId = null;
      c.model.saving = false;
    }
  }
});